import React from 'react';

import { Input } from '~/components/Form';
import { t } from '~/helpers';

export default function FormUser() {
  return (
    <>
      <Input
        name="senhaatual"
        label="Senha atual:"
        type="password"
      />

      <Input name="senhanova" label="Nova senha:" type="password" />

      <Input
        name="senhanovaconfirmada"
        label="Confirmar nova senha:"
        type="password"
      />
    </>
  );
}
